import React from "react";
import Project from "../components/Project/Project";

function ProjectsContainer(props) {
  return (
    <div className="one-second-animation">
      <div className="containers" id="projects-container">
        <h2 className="h2">Projects</h2>
        <Project />
      </div>
    </div>
  );
}

export default ProjectsContainer;
